import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { xCircle } from "@tql/ui-components-react/untitled/icons";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

import styles from "./index.module.css";

export const PaymentErrorModal = ({
	isOpen,
	errorMessage,
	onClose,
}: {
	isOpen: boolean;
	errorMessage: string;
	onClose?: () => void;
}) => {
	if (!isOpen) {
		return null;
	}
	return (
		<TraxModal onClose={onClose} title={"Payment Error"} width={"22%"}>
			<div className={styles.container}>
				<div className={styles.errorIcon}>
					<SvgIcon className={styles.icon} icon={xCircle} />
				</div>
				{errorMessage}
			</div>
		</TraxModal>
	);
};
